import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'string-popup-form',
  templateUrl: './string-popup-form.component.html',
  styleUrls: ['./string-popup-form.component.css'],
  providers: [ConfirmationService]
})
export class StringPopupFormComponent implements OnInit
{
  @Input() isVisible: boolean = false;
  @Input() type: string;
  @Input() isEdit: boolean = false;
  @Input() record: any;
  @Output() formSubmitted = new EventEmitter<boolean>();
  @Output() onHide = new EventEmitter<any>();

  localizationEndpointsUpdate: Record<string, string> = {
    'localization/client-strings': '/api/localization/client-strings/update',
    'localization/localized-strings': '/api/localization/localized-strings/update',
  };

  localizationEndpointsCreate: Record<string, string> = {
    'localization/client-strings': '/api/localization/client-strings/create',
    'localization/localized-strings': '/api/localization/localized-strings/create',
  };

  entity: any = {
    _recordId: null,
    field: null,
    Source_en: null,
    Target_frFR: null,
    Target_esMX: null,
    Target_deDE: null,
    verified: null,
    translationRequest: null,
  }
  values: any ={ id: null , cells: [
     {columnId: 'Source_en', value: null},
     {columnId: 'Target_frFR' , value: null},
     {columnId: 'Target_esMX' , value: null},
     {columnId: 'Target_deDE' , value: null},
     {columnId: 'verified' , value: null},
     {columnId: 'translationRequest', value: null}
  ]}

  constructor(
    private readonly http: HttpClient,
    private readonly messageService: MessageService,
  ) {}

  /**
   * Build Asset Component Initialization
   */
  ngOnInit(): void{}

  formSubmittedTrigger(event:any) {
    this.formSubmitted.emit(true);
  }

  onShow() {
    this.entity._recordId = this.record ? this.record.id : null;
    this.entity.field = this.record ? this.record.field : null;
    this.entity.Source_en = this.record ? this.record.Source_en : null;
    this.entity.Target_frFR = this.record ? this.record.Target_frFR : null;
    this.entity.Target_esMX = this.record ? this.record.Target_esMX : null;
    this.entity.Target_deDE = this.record ? this.record.Target_deDE : null;
    this.entity.verified = this.record ? this.record.verified : null;
    this.entity.translationRequest = this.record ? this.record.translationRequest : null;
  }

  onHideEmitter(){
    console.log('onHideEmitter');
    this.onHide.emit({hide: true});
  }

  hideDialog() {
    this.isVisible = false;
    this.onHideEmitter()
  }

  submitForm() {
    if (this.isEdit) {
      this.values.id = this.entity._recordId ? this.entity._recordId : this.entity.field ? this.entity.field : null;
      this.values.cells = [
        { columnId: 'Source_en', value: this.entity.Source_en ?? null },
        { columnId: 'verified', value: this.entity.verified ?? false },
      ];

      this.http.post(
        this.localizationEndpointsUpdate[this.type] || '/api/localization/update',
        this.values
      )
      .subscribe(
        (response: any) => {
          console.log('Post request successful:', response);
          if (response?.translation?.skipped) {
            this.messageService.add({
              sticky: true,
              severity: 'warn',
              summary: 'Record Saved — Translation Skipped',
              detail: 'This record is verified. Auto-translation was skipped. Use Force Translate to override.',
            });
          } else {
            this.messageService.add({
              sticky: true,
              severity: 'success',
              summary: 'Successfuly Updated a Record',
            });
          }
          this.formSubmitted.emit(true);
          this.hideDialog();
        },
        (error) => {
          console.error('Error in post request:', error);
          this.messageService.add(
            {
              sticky: true,
              severity: 'error',
              summary: 'Error Updating Record',
              detail: error?.error?.message || error?.message || 'An unexpected error occurred',
            });
        }
      );
    } else {
      this.values.id = this.entity._recordId ? this.entity._recordId : this.entity.field ? this.entity.field : null;
      this.values.cells.forEach((item: any) => {
        if (this.entity.hasOwnProperty(item.columnId)) {
          item.value = this.entity[item.columnId];
        }
      });

      console.log('values =>', this.values); // Optional: Log values before sending

      this.http.post(
        this.localizationEndpointsCreate[this.type] || '/api/localization/create',
        this.values
      )
        .subscribe(
          (response) => {
            console.log('Post request successful:', response);
            this.messageService.add(
              {
                sticky: true,
                severity: 'success',
                summary: 'Successfuly Added a Record',
              });
            this.formSubmitted.emit(true);
            this.hideDialog();
          },
          (error) => {
            console.error('Error in post request:', error);
            this.messageService.add(
              {
                sticky: true,
                severity: 'error',
                summary: 'Error Creating Record',
                detail: error?.error?.message || error?.message || 'An unexpected error occurred',
              });
          }
        );
    }
  }
}
